import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../../common/forms/FormItem';
import FormFooter from '../../../../common/forms/FormFooter';
import Select from '../../../../common/forms/select/Select';

const FORM_NAME = 'AddCargoToItineraryModalForm';

const AddCargoToItineraryModalForm = ({
  items,
  handleSubmit,
  options,
  dispatchChange,
}) => {
  const handleGlobalChange = (selectedOption) => {
    if (!selectedOption) return;
    items.forEach((item) => {
      dispatchChange(
        FORM_NAME,
        `destinationLocationId-${item.correlation}`,
        selectedOption,
      );
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row className="mb-4">
        <FormItem label="Destino para todos">
          <Select
            options={options}
            isClearable
            onValueChange={handleGlobalChange}
          />
        </FormItem>
      </FormGroup>

      <hr />

      {items.map((item) => (
        <div key={item.correlation}>
          <div className="mb-2">
            <span className="d-block">
              <strong>Correlativo:</strong> {item.correlation}
            </span>
            <span className="d-block">
              <strong>Descripción:</strong> {item.description}
            </span>
            <span className="d-block">
              <strong>Destino Final:</strong> {item.destinationCityName}
            </span>
          </div>
          <FormGroup row>
            <FormItem label="Destino">
              <Field
                name={`destinationLocationId-${item.correlation}`}
                component={Select}
                isClearable
                options={options}
              />
            </FormItem>
          </FormGroup>
        </div>
      ))}

      <FormFooter />
    </Form>
  );
};

AddCargoToItineraryModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  items: PropTypes.instanceOf(Immutable.List).isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  dispatchChange: PropTypes.func.isRequired,
};

AddCargoToItineraryModalForm.defaultProps = {};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'AddCargoToItineraryModalForm',
})(AddCargoToItineraryModalForm);

export default connect(null, mapDispatchToProps)(formComponent);
